import { z } from 'zod'
import {
  DEFAULT_MODAL_DELAY_SECONDS,
  DEFAULT_MODAL_FREQUENCY_DAYS,
  WIDGET_TYPES,
} from '@/constants'

export const WidgetAttributesSchema = z.object({
  // NOTE: This means that only "Appointments", "Schedules", "Pricing", "Registration", "Enrollments", and "Prospect" are allowed widget types, case sensitive
  widgetType: z.enum([
    WIDGET_TYPES.Appointments.type,
    WIDGET_TYPES.Schedules.type,
    WIDGET_TYPES.Pricing.type,
    WIDGET_TYPES.Registration.type,
    WIDGET_TYPES.Enrollments.type,
    WIDGET_TYPES.Prospect.type,
  ]),
  widgetId: z.string(),
  preview: z.string().nullable(),
  widgetMode: z
    .enum(['inline', 'modal'])
    .nullable()
    .transform((value) => value ?? 'inline')
    .catch('inline'),
  modalDelay: z
    .string()
    .regex(/^\d+$/)
    .nullable()
    .transform((value) => value ?? DEFAULT_MODAL_DELAY_SECONDS)
    .catch(DEFAULT_MODAL_DELAY_SECONDS),
  modalFrequency: z
    .string()
    .regex(/^\d+$/)
    .nullable()
    .transform((value) => value ?? DEFAULT_MODAL_FREQUENCY_DAYS)
    .catch(DEFAULT_MODAL_FREQUENCY_DAYS),
})
